<!--
 * @Author: zhaoliang
 * @Date: 2024-06-27 16:12:39
 * @LastEditTime: 2024-07-08 17:49:26
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/EnquiryForm/Modal.vue
 *
-->

<template>
  <div class="modal-mask" v-if="open">
    <div class="modal-containner">
      <h1 class="modal-title">{{ title }}</h1>
      <div class="modal-content">
        <slot name="content"></slot>
      </div>
      <div class="modal-footer">
        <button class="modal-ok-btn" @click="$emit('onOk')">{{ okText }}</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Modal',
    props: {
      title: {
        type: String,
        default: '',
      },
      open: {
        type: Boolean,
        default: false,
      },
      okText: {
        type: String,
        default: '',
      },
    },
    data() {
      return {};
    },
    created() {},
    mounted() {},
    methods: {},
    computed: {},
    watch: {},
  };
</script>
<style lang="scss" scoped>
  .modal-mask {
    @include wh(100%, 100%);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(22, 48, 73, 0.94);

    .modal-containner {
      position: fixed;
      top: 20%;
      left: 50%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 46%;
      max-width: 720px;
      padding: 50px 72px 38px;
      background: #fff;
      border-radius: 10px;
      transform: translateX(-50%);

      .modal-title {
        @include font(36px, 700);
        margin-bottom: 24px;
        color: #163049;
      }

      .modal-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        @include font($size: 21px, $weight: 400);
        text-align: center;
        line-height: 30px;
        flex-direction: column;

        input {
          width: 80%;
          margin-top: 10px;
          padding: 10px;
          border: 1px solid #9eacb5;
          border-radius: 5px;
          box-sizing: border-box;

          &.error {
            border-color: #cc2222;
          }
        }

        .err-msg {
          margin-top: 10px;
          @include font($size: 18px, $weight: 400);
          color: #cc2222;
        }
      }

      .modal-footer {
        margin-top: 24px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .modal-ok-btn {
          cursor: pointer;
          width: 80%;
          height: 64px;
          background-color: #c29d5c;
          color: #ffffff;
          @include font($size: 18px, $weight: 600);
          border-radius: 5px;
        }
        .modal-cancel-btn {
          margin-top: 24px;
          line-height: 1.5;
          @include font($size: 18px, $weight: 400);
          cursor: pointer;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .modal-mask {
      .modal-containner {
        width: 90%;
        padding: 30px 20px 30px;

        .modal-title {
          @include font(24px, 700);
          margin-bottom: 18px;
        }

        .modal-content {
          @include font($size: 12px, $weight: 400);
          line-height: 22px;

          input {
            width: 80%;
          }
        }

        .modal-footer {
          margin-top: 18px;

          .modal-ok-btn {
            width: 80%;
            height: 48px;
            @include font($size: 14px, $weight: 600);
          }
          .modal-cancel-btn {
            margin-top: 18px;
            @include font($size: 14px, $weight: 400);
          }
        }
      }
    }
  }
</style>
